module.exports = __webpack_public_path__ + "static/img/logo.fa8fe46b.png";